import React from 'react';
import CriteriaSubScores from "./CriteriaSubScores";
import CriteriaDetailTableRow from "./CriteriaDetailTableRow";
var CriteriaDetailWithSubscores = function CriteriaDetailWithSubscores(_ref) {
  var label = _ref.label,
    criteria = _ref.criteria;
  if (!criteria) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CriteriaDetailTableRow, {
    label: label,
    criteria: criteria
  }), /*#__PURE__*/React.createElement(CriteriaSubScores, {
    subScores: criteria === null || criteria === void 0 ? void 0 : criteria.subScores
  }));
};
export default CriteriaDetailWithSubscores;